import MobileServiceClient from "@mocobaas/client-js/build/MobileServiceClient";
import {
  GetListParams,
  GetListResult,
  GetOneParams,
  GetOneResult,
} from "react-admin";
import gql from "graphql-tag";
import { ProviderBase } from "./ProviderBase";
import { buildArgs } from "./utils";
import moment from "moment";
import { graphqlFetch } from "./smartfrenVirtualMsisdn";

const uriTest = "develop.m21-console.pages.dev";
const uriDev = "localhost:3000";
export class UsageRewardProviderClass extends ProviderBase<any> {
  client: MobileServiceClient;

  constructor(client: MobileServiceClient) {
    super();
    this.client = client;
  }

  async getList(
    resource: string,
    params: GetListParams
  ): Promise<GetListResult> {
    const where: Record<string, any> = {};
    const filterArray: any[] = [];
    const { filter } = params;
    const { page, perPage } = params.pagination;
    let { field, order } = params.sort;

    let dateGTE = moment().startOf("month").startOf("day").toISOString();
    let dateLTE = moment().endOf("month").endOf("day").toISOString();

    const args = buildArgs({
      order: order || "DESC",
      size: perPage,
      pageNumber: page,
      sort: field || "created_at",
    });

    if (filter.dateGte || filter.dateLte) {
      dateLTE = moment(params.filter.dateLte).toISOString();
      dateGTE = moment(params.filter.dateGte).toISOString();

      filterArray.push({
        created_at: {
          _gte: dateGTE,
        },
      });
      filterArray.push({
        created_at: {
          _lte: dateLTE,
        },
      });
    }

    if (filter.status) {
      filterArray.push({
        status: {
          _eq: filter.status,
        },
      });
    }

    if (filter.active_status) {
      if (filter.active_status === "ACTIVE") {
        filterArray.push({
          status: {
            _eq: "PURCHASED",
          },
        });
      } else if (filter.active_status === "NOT_ACTIVE") {
        filterArray.push({
          status: {
            _in: ["REDEEMED", "EXPIRED"],
          },
        });
      }
    }

    if (filter.code) {
      filterArray.push({
        code: {
          _ilike: `%${filter.code}%`,
        },
      });
    }

    if (filter.platform) {
      if (filter.platform === "GHK") {
        filterArray.push({
          subscriber_info: {
            _contains: {
              platform_info: {
                grapari_country: "HK",
                platform: "GHK",
              },
            },
          },
        });
      } else {
        const [platform, country] = filter.platform.split("_");
        filterArray.push({
          subscriber_info: {
            _contains: {
              platform_info: {
                grapari_country: null,
                platform,
              },
              subscriber: {
                country,
              },
            },
          },
        });
      }
    }

    if (filterArray.length > 0) where._and = filterArray;

    const queryResult = await graphqlFetch({
      url: [uriTest, uriDev].includes(window.location.host)
        ? "https://console.gql.m21-ng-core.develop.telinhk.xyz/mobile/v1/graphql"
        : "https://console.gql.m21-ng-core.live.telinhk.xyz/mobile/v1/graphql",
      query: `
            query allRewardLogsList($where: reward_logs_bool_exp
          $limit: Int
          $offset: Int
          $orderBy: [reward_logs_order_by!]){
            reward_logs(where: $where
                      limit: $limit
                      offset: $offset
                      order_by: $orderBy){
              id
                created_at
                updated_at
                user_id
                reward_catalogue_id
                reward_detail
                reward_code{
                  code
                }
                subscriber_info
                code
                delivery_history
                status
                user{
                  id
                  name
                  country
                }
            }
              reward_logs_aggregate(where: $where){
                aggregate{
                  count
                }
              }
          }`,
      variables: {
        where,
        limit: perPage,
        offset: (page - 1) * perPage,
        orderBy: [{ [field]: order.toLowerCase() }],
      },
    });
    return {
      data: queryResult?.data?.reward_logs || [],
      total: queryResult?.data?.reward_logs_aggregate?.aggregate?.count || 0,
    };
  }

  async getOne(
    resource: string,
    params: GetOneParams<any>
  ): Promise<GetOneResult<any>> {
    const queryResult = await graphqlFetch({
      url: [uriTest, uriDev].includes(window.location.host)
        ? "https://console.gql.m21-ng-core.develop.telinhk.xyz/mobile/v1/graphql"
        : "https://console.gql.m21-ng-core.live.telinhk.xyz/mobile/v1/graphql",
      query: `
            query getRewardById($id:uuid!){
              reward_logs_by_pk(id:$id){
                id
                created_at
                updated_at
                user_id
                reward_catalogue_id
                reward_detail
                subscriber_info
                reward_code{
                  code
                }
                code
                delivery_history
                status
              }
            }
          `,
      variables: {
        id: params?.id || "",
      },
    });

    return {
      data: queryResult?.data?.reward_logs_by_pk,
    };
  }
}
